import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, take } from 'rxjs';
import { SubscriptionFeeRepositoryService, Invoice, ConfigurationState } from 'reg-hub-common';
import { SubscriptionFee, FiltersComponent } from 'reg-hub-common';

@Component({
  selector: 'app-subscription-fees-list-filter',
  templateUrl: './subscription-fees-list-filter.component.html',
  styleUrl: './subscription-fees-list-filter.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionFeesListFilterComponent extends FiltersComponent<SubscriptionFee> implements OnInit {
  @Input() invoice!: Invoice;
  protected autoExpand: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private configurationState: ConfigurationState,
    subscriptionFeeRepository: SubscriptionFeeRepositoryService,
    formBuilder: FormBuilder,
    datePipe: DatePipe,
  ) {
    super(
      subscriptionFeeRepository,
      formBuilder,
      datePipe);
  }

  ngOnInit(): void {
    this._filterForm = this.formBuilder.group({
      invoiceID: [this.invoice.id],
      isInvoiced: [null],
      productCode: [null],
      taxCode: [null],
      addedDateFrom: [null],
      addedDateTo: [null],
      amountFrom: [null],
      amountTo: [null]
    });

    this._defaultParams = this.buildParamsFromForm(this._filterForm);

    this.configurationState.getCorporationID().then(corporationID => {
      this.repo.populateBaseLink([corporationID, this.invoice.id]);

      this.route.queryParams.pipe(take(1)).subscribe(routeQueryStringParams => {
        const routeQueryStringParamKeys = Object.keys(routeQueryStringParams);

        if (routeQueryStringParamKeys.length > 0) {
          let preFilteredParams = this.buildParamsFromObject(routeQueryStringParams);

          routeQueryStringParamKeys.forEach(key => {
            const control = this._filterForm.get(key);

            if (control) {
              control.setValue(routeQueryStringParams[key]);
              this._filterForm.markAsDirty();
              this.filtered = true;
            }
          })

          this.repo.getFirstPage(preFilteredParams);
        } else {
          this.repo.getFirstPage(this._defaultParams);
        }
      });
    })
  }
}